module.exports = __webpack_public_path__ + "img/Workflow-ability-01.8ec54197.png";